import { supabase } from '../supabaseClient';

export const checkoutsService = {
  async getAll() {
    const { data, error } = await supabase
      .from('checkouts')
      .select('*')
      .order('checked_out_at', { ascending: false });
    if (error) throw error;
    return data;
  },

  async create(checkout) {
    const { data, error } = await supabase
      .from('checkouts')
      .insert([checkout])
      .select()
      .single();
    if (error) throw error;
    return data;
  },

  async returnAsset(id, notes) {
    const { data, error } = await supabase
      .from('checkouts')
      .update({ status: 'Returned', returned_at: new Date().toISOString(), notes })
      .eq('id', id)
      .select()
      .single();
    if (error) throw error;
    return data;
  },
};
